module.exports = __webpack_public_path__ + "static/media/power2.8d099733.jpg";